<template>
  <div>
    <h4 class="my-4">
      {{ formTitle }}
    </h4>
    <div class="vx-col w-full vx-row justify-start">
      <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
        <label>التاريخ</label>
        <datepicker
          class="w-full"
          name="التاريخ"
          placeholder="التاريخ"
          type="date"
          v-model="newSession.date"
          format="yyyy-MM-dd"
        />
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
        <tm-input
          class="w-full"
          name="عدد المقاعد"
          placeholder="الحد الأقصى للمقاعد"
          type="number"
          v-model="newSession.maxSeats"
        />
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
        <tm-input
          class="w-full"
          name="وقت البدء"
          placeholder="وقت البدء"
          type="time"
          v-model="newSession.startAt"
        />
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
        <tm-input
          class="w-full"
          name="وقت الانتهاء"
          placeholder="وقت الانتهاء"
          type="time"
          v-model="newSession.endAt"
        />
      </div>
    </div>
    <div class="vx-row justify-start p-5">
      <vs-button
        type="filled"
        color="success"
        @click.prevent="addSession"
      >
        {{ isEdit ? "تأكيد التعديل" : " إضافة جلسة" }}
      </vs-button>
    </div>
    <vs-popup
      title="تكرار الجلسة"
      :active="openRepeatDialog"
      @close="$emit('updateOpenRepeatDialog', false)"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <label>من تاريخ</label>
          <datepicker
            v-model="localRepeatFromDate"
            format="yyyy-MM-dd"
          />
        </div>

        <div class="vx-col w-full mb-4">
          <label>إلى تاريخ</label>
          <datepicker
            v-model="localRepeatToDate"
            format="yyyy-MM-dd"
          />
        </div>

        <div class="vx-col w-full flex justify-end">
          <vs-button
            color="success"
            @click="confirmRepeatSession"
          >
            موافق
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import TmInput from "@/app/shared/shared-components/TmInput";
import Datepicker from 'vuejs-datepicker';

const regex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
function formatTime(date) {
  if (!date) return null;
  if (regex.test(date)) return date;

  return `${date}:00`;
}

export default {
  name: "TaskSessionForm",
  components: {
    TmInput,
    Datepicker,
  },
  props: {
    id: {
      type: [String, null],
      default: null,
    },
    date: {
      type: String,
      default: ''
    },
    startAt: {
      type: String,
      default: ''
    },
    endAt: {
      type: String,
      default: ''
    },
    maxSeats: {
      type: [String, Number],
      default: ''
    },
    openRepeatDialog: {
      type: Boolean,
      default: false
    },
    sessionToRepeat: {
      type: Object,
      default: null
    },
    repeatFromDate: {
      type: [String, Date, null],
      default: null
    },
    repeatToDate: {
      type: [String, Date, null],
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      newSession: {
        id: this.id,
        date: this.date,
        endAt: this.endAt,
        startAt: this.startAt,
        maxSeats: this.maxSeats
      },
      localRepeatFromDate: this.repeatFromDate,
      localRepeatToDate: this.repeatToDate,
    };
  },
  watch: {
    date(val) {
      this.newSession.date = val;
    },
    endAt(val) {
      this.newSession.endAt = val;
    },
    startAt(val) {
      this.newSession.startAt = val;
    },
    maxSeats(val) {
      this.newSession.maxSeats = val;
    },
  },
  methods: {
    addSession() {
      if (!this.newSession.date || !this.newSession.maxSeats) {
        return this.$vs.notify({
          title: 'خطأ',
          color: 'danger',
          text: 'لا يمكن إضافة جلسة بدون تاريخ و عدد مقاعد',
        });
      }
      this.$emit("addSession", {
        ...this.newSession,
        endAt: formatTime(this.newSession.endAt),
        maxSeats: Number(this.newSession.maxSeats),
        startAt: formatTime(this.newSession.startAt),
      });
      this.newSession = {
        id: null,
        date: '',
        endAt: '',
        startAt: '',
        maxSeats: ''
      };
      this.$emit('update:isEdit', false);
    },
    confirmRepeatSession() {
      if (!this.localRepeatFromDate || !this.localRepeatToDate) {
        return this.$vs.notify({
          title: 'خطأ',
          color: 'danger',
          text: 'يرجى اختيار تاريخ التكرار',
        });
      }

      const start = new Date(this.localRepeatFromDate);
      const end = new Date(this.localRepeatToDate);

      const sessionsRepeatd = [];

      for (
        let date = new Date(start);
        date <= end;
        date.setDate(date.getDate() + 1)
      ) {
        sessionsRepeatd.push({
          ...this.newSession,
          date: new Date(date),
          endAt: this.sessionToRepeat.endAt,
          startAt: this.sessionToRepeat.startAt,
          maxSeats: this.sessionToRepeat.maxSeats,
        });
      }
      this.$emit("addSessions", sessionsRepeatd);
      this.$vs.notify({
        title: 'تم بنجاح',
        color: 'success',
        text: `تمت إضافة ${sessionsRepeatd.length} جلسة بنجاح`,
      });
      this.$emit('updateOpenRepeatDialog', false);
      this.$emit('clearSessionToRepeat', null);
      this.localRepeatFromDate = null;
      this.localRepeatToDate = null;
    }

  },
  computed: {
    formTitle() {
      return this.isEdit
        ? 'تعديل الجلسة'
        : 'إضافة جلسة جديدة';
    }
  }
};
</script>
<style>
  .vs-popup--content {
    overflow: visible !important;
  }
</style>
